export default __webpack_public_path__ + "static/graphik-semibold-web-aebf8154d4572f0b07e487950b190a13.woff";